import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import { MAIN_URL } from "../../../Configurations/Urls";

// Lazy load to avoid circular imports at build time
const ClientReports = React.lazy(() =>
  import("./ClientReports")
);
const ProjectReports = React.lazy(() =>
  import("./ProjectReports")
);

export default function ProjectClientRedirect() {
  const { userData } = useAuthStore();
  const role = userData?.organizationuser.user_types.user_type_name?.toLowerCase();
  const email = userData.activeOrganizationUser.email;

  const [clientIds, setClientIds] = useState(null);
  const [loadingClient, setLoadingClient] = useState(true);

  useEffect(() => {
    let isMounted = true;
    // Only bother fetching if role is client; otherwise, no need
    if (role === "client") {
      const fetchClientByEmail = async () => {
        setLoadingClient(true);
        try {
          const token = localStorage.getItem("token");
          const res = await fetch(
            `${MAIN_URL}/api/project-management/clients/by-email/${email}`,
            {
              headers: {
                ...(token && { Authorization: `Bearer ${token}` }),
              },
            }
          );

          if (res.ok) {
            const json = await res.json();
            if (isMounted) {
              setClientIds(json?.data);
            }
          } else {
            if (isMounted) setClientIds(null);
          }
        } catch {
          if (isMounted) setClientIds(null);
        } finally {
          if (isMounted) setLoadingClient(false);
        }
      };
      fetchClientByEmail();
    } else {
      // if not a client user, no need to fetch clientIds
      setLoadingClient(false);
      setClientIds(null);
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [email, role]);

  if (role === "client") {
    if (loadingClient) {
      // Simple loader
      return (
        <div style={{ padding: "3rem 0", display: "flex", justifyContent: "center" }}>
          <div style={{
            border: "4px solid #e3e3e3",
            borderTop: "4px solid #4285f4",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            animation: "spin 1s linear infinite"
          }} />
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg);}
                100% { transform: rotate(360deg);}
              }
            `}
          </style>
        </div>
      );
    }

    if (!clientIds || !Array.isArray(clientIds) || clientIds.length === 0) {
      // No client associations
      return (
        <div style={{
          textAlign: "center",
          marginTop: "3rem",
          color: "#6b7280",
          fontSize: "1.1rem"
        }}>
          No associated clients found.
        </div>
      );
    }

    // If only one client, pass client id straight through
   
      return (
        <React.Suspense fallback={<div>Loading...</div>}>
          <ClientReports clientId={clientIds[0].organization_client_id} />
        </React.Suspense>
      );
    

    // Multiple clients: ask user to pick, reuse ClientIndex picker UI
    
  }

  // Non-client user: render project-wide report/dashboard
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <ProjectReports />
    </React.Suspense>
  );
}